module.exports = __webpack_public_path__ + "static/media/air-conditioner.01052567.svg";